// flow weak

import React, {
    Component
  }                         from 'react';
  import PropTypes          from 'prop-types';
  import {
    AnimatedView,
    StatsTable,
    MaterialList
  }                         from '../../../components';
  import styles                 from './style';
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import {Link} from 'react-router-dom';
  import FlatButton from 'material-ui/FlatButton';
  import styled from 'styled-components';
  import { Spinner } from 'react-activity';
  import AddInventoryItem from '../crud/addInventoryItem';
  import AddInventoryEntry from '../crud/addInventoryEntry'

  
  class Inventory extends Component {
    static propTypes = {
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        headers:[],
        inventory_data:[],
        loading: true,
        section:'inventory_home',
      };
      this.onButtonClick = this.onButtonClick.bind(this);
    }
  
    componentWillMount() {
      const { actions: { enterPage } } = this.props;
      enterPage('Home');
    }
  
    componentDidMount() {
      this.getInventoryList();
    }
  
    componentWillUnmount() {
      const { actions: { leavePage } } = this.props;
      leavePage('Home');
    }

    onButtonClick(tabname){
        this.setState({section:tabname})
    }

    getInventoryList() {
      var url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=7000`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => {
            this.setState({inventory_data:data.data,headers:data.headers})
         }).catch(error => error);
    }
    
    renderInventoryList(){
        return(
            <div className='col-md-12 table_container1' style={styles.table}>
              <div className="heading heading2 left" style={styles.header}>List of Inventories</div> 
              <table className="table_plain">
                <tr> 
                  {this.state.headers.map((head)=>
                    <th>{head}</th>
                  )
                }
                </tr>
                
                  { this.state.inventory_data && this.state.inventory_data.length > 0 ?
                    this.state.inventory_data.map((data)=>
                      <tr>
                        { data.map((each)=>
                          <td dangerouslySetInnerHTML={{__html:each}}></td>
                          )
                        }
                      </tr>
                      )
                    :
                    
                    this.state.headers.length == 0 ?
                    <div style={{height:500}}>
                      <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
                    </div>
                    :
                    this.state.headers.length > 0 ?
                    <div style={{height:500}}>
                      <div style={{  position: 'absolute',top: '25%',left: '50%',width: '50%',height: '50%'}}> No Data Available</div>
                    </div>
                    :
                    <div style={{height:500}}>
                      <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
                    </div>
                    
                  }
              </table>
            </div>
            )
    }

    
  
    render() {
      console.log('venue',this.state.section)
      return(
        <div>
             <div className="breadcrumps" style={{'paddingLeft': "1%",'marginBottom':"1%"}}>
                <a  onClick={() =>{this.onButtonClick('inventory_home')}} >
                    <span>Inventory</span>
                </a> 
                {this.state.section == 'add_item'  &&
                <a  >
                    <span>Add Item</span>
                </a> }
                {this.state.section == 'add_entry'  &&
                <a  >
                    <span>Add Entry</span>
                </a> }
                {this.state.section == 'request_item'  &&
                <a  >
                    <span>Request Item</span>
                </a> }
            </div>
            <div className='row' style={{textAlign:'center',display:'flex',justifyContent:'flex-end'}}>
            <div >
                <button className='button1' onClick={()=>{this.onButtonClick('add_item')}}>Add Item </button>
                <button className='button1' onClick={()=>{this.onButtonClick('add_entry')}}>Add Entry </button>
                <button className='button1' onClick={()=>{this.onButtonClick('request_item')}}>Request Items </button>
        
                </div>
            </div>
            {this.state.section == "add_item" &&
            <AddInventoryItem />
            }
            {this.state.section == 'add_entry' &&
            <AddInventoryEntry />
            }
            {this.state.section == "request_item" &&
            <AddInventoryItem />
            }
            {this.state.section == "inventory_home" &&
                this.renderInventoryList()
            }         
        </div>
      );
    }
  }
  
  export default Inventory;
  


// WEBPACK FOOTER //
// ./src/app/views/centerportal/inventory/Inventory.js